module.exports = __webpack_public_path__ + "img/logo_2.51f3cd31.png";